<div class="settings settings-content">
  <content-title-v2 [title]="'Settings.User.titleV2' | translate" />

  <div class="settings-content-section-forms">
    <user-base-data [form]="form" />
    <user-password [disabled]="!(storage.UserPerson.registrationMethod !== 'google')" />
  </div>
</div>
